module.exports = __webpack_public_path__ + "img/Totodile.b68492f4.gif";